import { useMemo } from 'react'
import { TrunkingSite } from '../../app/types'
import { SectionedForm } from '../../common/components/SectionedForm'
import { usePrivilege } from '../../common/util/hooks'
import { FeaturePrivileges } from '../../common/util/featurePrivileges'
import { useGeneralSection } from '../general'
import { useSoiRegistrationConfigSection } from './soiRegistrationConfig'
import { useSoiRegistrationInfoSection } from './soiRegistrationInfo'
import { Grid } from '@mui/material'

export const SoiRegistrationDetail = (isFetching: boolean, error: any, refetch: () => void, data?: TrunkingSite) => {

    const { hasAccess: hasWriteAccess } = usePrivilege(FeaturePrivileges.trunkSite.write)

    const generalSection = useGeneralSection(isFetching, error, refetch, data);
    const soiRegistrationConfigSection = useSoiRegistrationConfigSection(data, !hasWriteAccess);
    const soiRegistrationInfoSection = useSoiRegistrationInfoSection(data);

    const formSections = useMemo(() => [
        generalSection, soiRegistrationConfigSection, soiRegistrationInfoSection
    ], [generalSection, soiRegistrationConfigSection, soiRegistrationInfoSection ])

    return <Grid container >
        <SectionedForm formSections={formSections} activeTab={0} readOnly={!hasWriteAccess}/>
    </Grid>
}
